module.exports = __webpack_public_path__ + "close.svg?383f87ce2ea94c6a61434db967828fde";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diving_icons/close.svg
// module id = 149
// module chunks = 0